import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';
import { IAppItem } from './Modules.Interface';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    /** 我的APP */
    public myAppList: IAppItem[] = [];
    /** app类型 */
    public appCategoryList: {
        categoryId: number;
        categoryName: string;
    }[] = [];
    /** 选中的app类型 */
    public appCategory: number = 0;
    /** 私有应用 公有 所有 */
    public isOpen: string = 'all';
    public isOpenList: Array<{
        name: string;
        id: string;
    }> = [
            { id: 'all', name: '全部应用' },
            { id: '1', name: '公开应用' },
            { id: '0', name: '私有应用' },
            { id: 'myApp', name: '我的应用' },
        ];
    /** 模糊搜索 */
    searchInfo: {
        appName?: string;
        appCategoryId?: any;
        isOpen?: string;
    } = {
            appName: '',
            appCategoryId: '',
            isOpen: 'all'
        };
    screenListData: any[];
}


// WEBPACK FOOTER //
// ./src/display/apps/AppSearch/Modules.State.ts